import { size, __spreadValues } from './chunk-JJ6VZ5V7.mjs';
import * as React from 'react';
import styled, { color } from '@xstyled/styled-components';

var SvgComponent = (props) => /* @__PURE__ */ React.createElement(
  "svg",
  __spreadValues({
    xmlns: "http://www.w3.org/2000/svg",
    width: "24px",
    height: "24px",
    fill: "none",
    "aria-hidden": "true",
    viewBox: "0 0 24 24"
  }, props),
  /* @__PURE__ */ React.createElement(
    "path",
    {
      fill: "currentColor",
      fillRule: "evenodd",
      d: "M8 3a2 2 0 0 0-2 2v15a2 2 0 0 0 2 2h8a2 2 0 0 0 2-2V5a2 2 0 0 0-2-2h-1l-.414-.414A2 2 0 0 0 13.172 2h-2.344a2 2 0 0 0-1.414.586L9 3zm4 3-4 8h4v5l4-8h-4z",
      clipRule: "evenodd"
    }
  )
);
var SvgBatterySafeFilled = styled(SvgComponent)`
  ${size}
  ${color}
`;
var BatterySafeFilled_default = SvgBatterySafeFilled;

export { BatterySafeFilled_default as default };
